// Local Storage Keys
export const AUTHENTICATION_LOCAL_STORAGE_KEY = "AuthenticationLocalStorageKey";

// Action Types
export const LOGIN_REQUEST = "login_request";
export const LOGIN_ERROR = "login_error";
export const LOGIN_LOADING = "login_loading";
export const LOGIN_SUCCESS = "login_success";
export const LOGOUT_USER = "login_user";
